import Axios from 'axios';

export const API = Axios;

export const createUrlParamsFromObject = (obj: any) => 
  Object.keys(obj)
    .map(prop => `${prop}=${obj[prop]}`)
    .join('&');
